import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";
import Container from "reactstrap/lib/Container";
import { webpSimpleTransformer } from "Helpers/ImageManager";
import { PaddingBottom } from "ComponentsUI/Spacings";
import { BackgroundImage } from "ComponentsUI/BackgroundImage";
import { HeaderTextSeo } from "ComponentsUI/SeoBlock";

const styles = (theme) => {
	return {
		root: {
			position: "relative",
		},
		header: {
			fontSize: "28px",
			fontFamily: theme.fonts.bold,
			lineHeight: 1,
			color: theme.palette.colors.darkSlateBlue,
			textAlign: "center",
			marginBottom: "20px",
		},
		subheader: {
			fontSize: "18px",
			fontFamily: theme.fonts.light,
			lineHeight: 1.17,
			color: theme.palette.colors.darkSlateBlue,
			textAlign: "center",
			margin: "0 auto 30px",
			maxWidth: "600px",
		},
		background: {
			padding: "60px",
			"& $header, & $subheader": {
				color: theme.palette.colors.white,
			},
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			header: {
				fontSize: "26px",
				marginBottom: "20px",
			},
			subheader: {
				fontSize: "16px",
				margin: "0 auto 40px",
			},
			background: {
				padding: "40px",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				marginBottom: "25px",
			},
			header: {
				fontSize: "20px",
				marginBottom: "20px",
			},
			subheader: {
				fontSize: "14px",
				margin: "0 auto 30px",
				maxWidth: "80%",
			},
			background: {
				padding: "20px",
			},
		},
	};
};

class SearchAddressWrapper extends React.Component {
	render() {
		let classes = this.props.classes;
		let text = this.props.text;
		let seoBlock = this.props.seoBlock || {};
		return (
			<PaddingBottom>
				<div
					className={classNames(classes.root, {
						[classes.background]: this.props.background,
					})}
				>
					{this.props.background && (
						<BackgroundImage
							webpTransformer={webpSimpleTransformer}
							windowSizes={this.props.windowSizes}
							background={this.props.background}
						/>
					)}
					{!this.props.hideTitle && (
						<Container>
							<HeaderTextSeo
								header={seoBlock.seoHeader || text.WHERE_CONNECT_INTERNET}
								text={seoBlock.seoText || text.hero_text_to_video_1}
							/>
						</Container>
					)}
					{this.props.children}
				</div>
			</PaddingBottom>
		);
	}
}
export default withStyles(styles)(SearchAddressWrapper);
